export default __webpack_public_path__ + "static/media/375.ede9646f.gif";